/**
 * Swaps a broken app icon on the available-products cards for the Cropwise
 * favicon, so an app whose S3 icon is missing degrades to the brand mark
 * instead of the browser's broken-image glyph.
 */
const FALLBACK_ICON_SRC = '/cropwise-accounts-assets/favicon.svg';

const applyIconFallback = (img) => {
  // Reassigning the same src restarts the request, so a failing fallback would
  // loop between the error listener and the already-failed check below.
  if (img.getAttribute('src') === FALLBACK_ICON_SRC) return;

  img.setAttribute('src', FALLBACK_ICON_SRC);
};

export const initAvailableProductsCardIcons = () => {
  for (const img of document.querySelectorAll('img.available-products__card-icon')) {
    // The listener alone misses icons that failed before init (error won't
    // re-fire); the immediate check alone misses icons still in flight.
    img.addEventListener('error', () => applyIconFallback(img), { once: true });
    if (img.getAttribute('src') && img.complete && img.naturalWidth === 0) {
      applyIconFallback(img);
    }
  }
};
